export default { //buat yg muncul di kiri.
  	items: [
		{
			name: 'Dashboard',
			url: '/dashboard',
			icon: 'fa fa-home',
			code: 'DAS',
		},
		{
			name: 'Laporan Saya',
			url: '/laporan-saya',
			// code: 'RKC',
			code: 'DAS',
			icon: 'fa fa-tasks',
		},
		{
			name: 'Master',
			url: '/master',
			icon: 'fa fa-user',
			code: 'MST',
			children: [
				{
					name: 'Jenis Barang',
					url: '/master/jenis-barang',
					code: 'MJE',
				},
				{
					name: 'Merk Barang',
					url: '/master/merk-barang',
					code: 'MME',
				},
				{
					name: 'Tipe Barang',
					url: '/master/tipe-barang',
					code: 'MTI',
				},
				{
					name: 'IMEI Database',
					url: '/master/imei-database',
					code: 'MIR',
				},
				{
					name: 'Nomor Model Database',
					url: '/master/model-database',
					code: 'MMD',
				},
				{
                    name: 'Setting Emas',
                    url: '/master/harga-emas',
                    code: 'MHE',
                },
				{
                    name: 'Cap Emas',
                    url: '/master/cap-emas',
                    code: 'MCG',
                },
				{
                    name: 'Kemasan Emas',
                    url: '/master/kemasan-emas',
                    code: 'MKG',
                },
                {
                    name: 'Kelompok Barang',
                    url: '/master/kelompok-barang',
                    code: 'MKE',
                },
				{
					name: 'Cabang',
					url: '/master/cabang',
					code: 'MCA',
				},
				{
					name: 'Anggota',
					url: '/master/anggota',
					code: 'MAN',
				},
				{
					name: 'Pekerjaan Nasabah',
					url: '/master/pekerjaan-nasabah',
					code: 'MPK',
				},
				{
					name: 'Alasan Reject Gadai',
					url: '/master/alasan-reject-gadai',
					code: 'MAR',
				},
				{
					name: 'Bank',
					url: '/master/bank',
					code: 'BNK',
				},
				{
					name: 'User Staff',
					url: '/master/user-staff',
					code: 'MUS',
				},
				{
					name: 'Role',
					url: '/master/role',
					code: 'MRO',
				},
				{
					name: 'Promo',
					url: '/master/promo',
					code: 'MPR',
				},
				{
					name: 'Master Promo Mobile',
					url: '/master/promo-mobile',
					code: 'MPM',
				},
				{
					name: 'Parameter',
					url: '/master/parameter',
					code: 'MPA',
				},
				{
					name: 'Akses Menu',
					url: '/master/akses-menu',
					code: 'MAK',
				},
				{
						name: 'Banner Mobile',
						url: '/master/banner-mobile',
						code: 'MBM'
				},
				{
					name: 'Blacklist Nasabah',
					url: '/master/blacklist-nasabah',
					code: 'MBN'
				},
				{
					name: 'Blacklist IMEI',
					url: '/master/blacklist-imei',
					code: 'MBI'
				},
				// {
				// 	name: 'Blacklist Rekening',
				// 	url: '/master/blacklist-rekening',
				// 	code: 'MBN'
				// },
				{
					name: 'Voucher',
					url: '/master/voucher',
					code: 'MVC',
				},
				{
					name: 'Wilayah',
					url: '/master/wilayah',
					code: 'MEW',
				},
				{
					name: 'Kas Kecil',
					url: '/master/kas-kecil',
					code: 'MMB',
				},
			]
		},
		{
			name: 'Gadai',
			url: '/gadai',
			icon: 'fa fa-plus-square',
			code: 'GAD',
			children: [
				{
					name: 'Simulasi Gadai',
					url: '/gadai/simulasi',
					code: 'GSI',
				},
				{
					name: 'Simulasi Pembayaran',
					url: '/gadai/simulasi-pembayaran',
					code: 'GSP',
				},
				{
					name: 'Perpanjangan',
					url: '/gadai/perpanjangan',
					code: 'GPP',
				},
				{
					name: 'Pelunasan',
					url: '/gadai/pelunasan',
					code: 'GPL',
				},
				{
					name: 'Bukti Gadai & PL',
					url: '/gadai/bukti-gadai',
					code: 'GBG',
				},
				{
					name: 'Daftar Gadai',
					url: '/gadai/daftar',
					code: 'GDA',
				},
				{
					name: 'Reject Gadai',
					url: '/gadai/reject-gadai',
					code: 'GRE',
				},
				{
					name: 'Pencarian Faktur',
					url: '/gadai/inquiry-faktur',
					code: 'GIF',
				},
				{
					name: 'Antrian Mobile',
					url: '/gadai/antrian',
					code: 'GAM'
				},
				{
					name: 'Daftar Penarikan',
					url: '/gadai/daftar-penarikan',
					code: 'GDP',
				},
				{
					name: 'Elektronik',
					url: '/gadai/elektronik',
					code: 'GEL',
				},
				{
					name: 'Kendaraan',
					url: '/gadai/kendaraan',
					code: 'GKE',
				},
				{
					name: 'Emas',
					url: '/gadai/emas',
					code: 'GEM',
				},
				{
					name: 'Kalibrasi',
					url: '/gadai/kalibrasi',
					code: 'GKI',
				},
				{
					name: 'Klaim Hadiah',
					url: '/gadai/klaim-hadiah',
					code: 'VMC',
				},
			]
		},
		{
			name: 'Persetujuan',
			url: '/persetujuan',
			icon: 'fa fa-check',
			code: 'STJ',
			children: [
				{
					name: 'Cek Gadai',
					url: '/persetujuan/cek-gadai',
					code: 'SCE',
				},
				{
					name: 'Edit Gadai',
					url: '/persetujuan/edit-gadai',
					code: 'SED',
				},
				{
					name: 'Keringanan',
					url: '/persetujuan/keringanan',
					code: 'SKE',
				},
				{
					name: 'Void Pembayaran',
					url: '/persetujuan/void-pembayaran',
					code: 'SVO',
				},
				{
					name: 'Kas Keluar',
					url: '/persetujuan/kas-keluar',
					code: 'SKK',
				},
				{
					name: 'Barang Hilang',
					url: '/persetujuan/barang-hilang',
					code: 'SBH',
				},
				{
					name: 'Cek IMEI',
					url: '/persetujuan/cek-imei',
					code: 'SCI',
				},
				{
					name: 'Serah Terima Jabatan',
					url: '/persetujuan/serah-terima',
					code: 'STJ',
				},
				{
					name: 'Edit Tipe Pelunasan',
					url: '/persetujuan/edit-tipe-pelunasan',
					code: 'STP',
				},
				{
					name: 'Audit Rekening',
					url: '/persetujuan/audit-rekening',
					code: 'VNB',
				},
				{
					name: 'Disbursement',
					url: '/persetujuan/disbursement',
					code: 'PDG',
				},
				{
					name: 'Edit Anggota',
					url: '/persetujuan/edit-anggota',
					code: 'SUN'
				},
				{
					name: 'Anggota Baru',
					url: '/persetujuan/anggota-baru',
					code: 'VNN'
				},
				{
					name: 'Catatan Kas',
					url: '/persetujuan/catatan-kas',
					code: 'SKL',
				},
			]
		},
		{
			name: 'Admin',
			url: '/admin',
			icon: 'fa fa-cogs',
			code: 'ADM',
			children: [
				{
					name: 'Pemulihan Pembayaran',
					url: '/admin/pemulihan-pembayaran',
					code: 'ADM',
				},
			]
		},
		{
			name: 'Pusat',
			url: '/pusat',
			icon: 'fa fa-building',
			code: 'PST',
			children: [
				{
					name: 'Daftar Void Gadai',
					url: '/pusat/daftar-void-gadai',
					code: 'PVG',
				},
				{
					name: 'Daftar Void Pembayaran',
					url: '/pusat/daftar-void-pembayaran',
					code: 'PVP',
				},
				{
					name: 'Daftar Cek Gadai',
					url: '/pusat/daftar-cek-gadai',
					code: 'PCG',
				},
				{
					name: 'Daftar Edit Gadai',
					url: '/pusat/daftar-edit-gadai',
					code: 'PEG',
				},
                {
                    name: 'Daftar Antrian Mobile',
                    url: '/pusat/daftar-antrian-mobile',
                    code: 'PAM',
                },
                {
                    name: 'Daftar Transaksi Online',
                    url: '/pusat/daftar-transaksi-online',
                    code: 'PTO',
                },
				{
					name: 'Surat BPKB',
					url: '/pusat/surat-bpkb',
					code: 'PSB'
				},
				{
					name: 'Daftar Penarikan',
					url: '/pusat/daftar-penarikan',
					code: 'PDP'
				},
				{
					name: 'SMS',
					url: '/pusat/sms',
					code: 'PSM'
				},
				{
					name: 'Monitoring IP',
					url: '/pusat/monitoringip',
					code: 'PMI'
				},
				{
					name: 'Data Jurnal',
					url: '/pusat/data-jurnal',
					code: 'PDJ'
				},
				{
					name: 'Audit Pelunasan',
					url: '/pusat/audit-pelunasan',
					code: 'PAP'
				},
				{
					name: 'Isi Excel',
					url: '/pusat/isi-excel',
					code: 'PFE'
				},
				{
					name: 'Daftar Edit IMEI',
					url: '/pusat/daftar-edit-imei',
					code: 'UGI'
				},
				{
					name: 'Daftar Disbursement',
					url: '/pusat/daftar-disbursement',
					code: 'PDD'
				},
			]
		},
		{
			name: 'Kasir',
			url: '/kasir',
			icon: 'fa fa-calculator',
			code: 'KSR',
			children: [
				{
					name: 'Transaksi Gadai',
					url: '/kasir/transaksi-gadai',
					code: 'KTG',
				},
                {
					name: 'Transaksi Pembayaran',
					url: '/kasir/transaksi-pembayaran',
					code: 'KTP',
				},
                {
					name: 'Transaksi Online',
					url: '/kasir/transaksi-online',
					code: 'KTO',
				},
                // {
				// 	name: 'Transaksi QRIS v1',
				// 	url: '/kasir/transaksi-qris',
				// 	code: 'KTQ',
				// },
                {
					name: 'Transaksi QR V2',
					url: '/kasir/transaksi-qr-v2',
					code: 'KTQ',
				},
                {
					name: 'Kas Mutasi',
					url: '/kasir/kas-mutasi',
					code: 'KKA',
				},
				{
					name: 'Transaksi Kas Masuk',
					url: '/kasir/transaksi-kas-masuk',
					code: 'KKM',
				},
				{
					name: 'Transaksi Kas Keluar',
					url: '/kasir/transaksi-kas-keluar',
					code: 'KKK',
				},
				{
					name: 'Kas Virtual',
					url: '/kasir/kas-virtual',
					code: 'KKV',
				},
				{
					name: 'Catatan Kas',
					url: '/kasir/catatan-kas',
					code: 'KML',
				},
				{
					name: 'Operasional Kas',
					url: '/kasir/operasional-kas',
					code: 'KLB',
				},
				{
					name: 'Kas Kecil',
					url: '/kasir/kas-kecil',
					code: 'MRC,AMC,MIE,MVR,MAV,MPP,MBH,MXL',
				},
				{
					name: 'Disbursement Pending',
					url: '/kasir/disbursement-pending',
					code: 'KDP',
				},
			]
		},
		{
			name: 'Informasi Umum',
			url: '/informasi-umum',
			icon: 'fa fa-home',
			code: 'INF',
		},
		{
			name: 'Lelang',
			url: '/lelang',
			icon: 'fa fa-laptop',
			code: 'LEL',
			children: [
				{
					name: 'Order Lelang',
					url: '/lelang/order-lelang',
					code: 'LBA',
				},
				{
					name: 'Persiapan Lelang',
					url: '/lelang/persiapan-lelang',
					code: 'LPE',
				},
				{
					name: 'Penjualan',
					url: '/lelang/penjualan',
					code: 'LPJ',
				},
				{
					name: 'Kirim Balik',
					url: '/lelang/kirim-balik',
					code: 'LKB',
				},
				{
					name: 'Drop Off',
					url: '/lelang/drop-off',
					code: 'LDO,LPO',
				}
			]
		},
		{
			name: 'Laporan',
			url: '/laporan',
			icon: 'fa fa-tasks',
			code: 'LAP',
			children: [
				{
					name: 'Laporan Stok Gudang',
					url: '/laporan/laporan-stok-gudang',
					code: 'RSG',
				},
				{
					name: 'Laporan Pembayaran',
					url: '/laporan/laporan-pembayaran',
					code: 'RPB',
				},
				{
					name: 'Laporan Pelunasan',
					url: '/laporan/laporan-pelunasan',
					code: 'RPL',
				},
				{
					name: 'Laporan Kas Masuk',
					url: '/laporan/laporan-kas-masuk',
					code: 'RMA',
				},
				{
					name: 'Laporan Kas Keluar',
					url: '/laporan/laporan-kas-keluar',
					code: 'RKE',
				},
				{
					name: 'Laporan Kas Mutasi',
					url: '/laporan/laporan-kas-mutasi',
					code: 'RMU',
				},
				{
					name: 'Laporan Buku Besar',
					url: '/laporan/laporan-buku-besar',
					code: 'RBB',
				},
				{
					name: 'Laporan Kas Cabang',
					url: '/laporan/laporan-kas-cabang',
					code: 'RKC',
				},
				{
					name: 'Laporan Kembar IMEI / SN',
					url: '/laporan/laporan-kembar-imei',
					code: 'RKI',
				},
			]
		},
        {
			name: 'Laporan Harian Cabang',
			url: '/laporan-harian-cabang',
			icon: 'fa fa-tasks',
			code: 'LHC',
			children: [
				{
					name: 'Serah Terima Gadai',
					url: '/laporan-harian-cabang/serah-terima-gadai',
					code: 'CGB',
				},
				{
					name: 'Serah Terima Gadai Lunas',
					url: '/laporan-harian-cabang/serah-terima-gadai-lunas',
					code: 'CGL',
				},
				{
					name: 'Serah Terima Gadai Perpanjangan',
					url: '/laporan-harian-cabang/serah-terima-gadai-perpanjangan',
					code: 'CGP',
				},
				{
					name: 'Transaksi Harian',
					url: '/laporan-harian-cabang/transaksi-harian',
					code: 'CTH',
				},
				{
					name: 'Transaksi Lintas Cabang',
					url: '/laporan-harian-cabang/transaksi-lintas-cabang',
					code: 'CLC',
				}
			]
		},
		{
			name: 'Laporan Eksekutif',
			url: '/laporan eksekutif',
			icon: 'fa fa-tasks',
			code: 'EKS',
			children: [
				{
					name: 'Laporan Omzet',
					url: '/laporan-eksekutif/laporan-omzet',
					code: 'EOM',
				},
				{
					name: 'Laporan Gadai Baru',
					url: '/laporan-eksekutif/laporan-gadai-baru',
					code: 'EGB',
				},
				{
					name: 'Laporan Pemasukan',
					url: '/laporan-eksekutif/laporan-pemasukan',
					code: 'EPE',
				},
				// {
				// 	name: 'Laporan PP/ PL',
				// 	url: '/laporan-eksekutif/laporan-pp-pl',
				// 	code: 'EPL',
				// },
				{
					name: 'Daftar BPKB Macet',
					url: '/laporan-eksekutif/daftar-bpkb-macet',
					code: 'EBM',
				},
				{
					name: 'Daftar Gadai Aktif',
					url: '/laporan-eksekutif/daftar-gadai-aktif',
					code: 'EGA',
				},
				{
					name: 'Laporan Penjualan',
					url: '/laporan-eksekutif/laporan-penjualan',
					code: 'EJU',
				}
			]
		},
		{
			name: 'Akses Laporan Eksekutif',
			url: '/akses-laporan-eksekutif',
			icon: 'fa fa-key',
			code: 'ALE',
		},
	]
}
